import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_CHAT_HOLIDAYS2 } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_CHAT_HOLIDAYS2";

export const getSettingChatHolidays = (): number[] => {
  return getSettingValueWithoutAssignment(
    HELP_CENTER_CHAT_HOLIDAYS2,
    [1700697600000, 1703462400000, 1704067200000]
  );
};
